<template>
  <div class="campaign_stat_box">
    <div class="campaign_stat_box--sections">
      <div class="campaign_stat_box--section">
        <h4 class="campaign_stat_box--section--heading">{{ label }}</h4>

        <div class="campaign_stat_box--section--stat">
          <p class="campaign_stat_box--section--stat--count">{{ count }}</p>
        </div>
      </div>

      <div class="campaign_stat_box--section" v-if="chartData.length !== 0">
        <chart-pie
          :data-is-loaded="chartDataIsLoaded"
          :chart-data="chartData"
        />
      </div>

      <div class="campaign_stat_box--section">
        <h4 class="campaign_stat_box--section--heading">{{ costLabel }}</h4>

        <div class="campaign_stat_box--section--stat">
          <p class="campaign_stat_box--section--stat--count">{{ formatCurrency(costAmount) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../../services/utils";
import ChartPie from "../../../components/charts/ChartPie.vue";

export default {
  name: "StatsCampaignsBox",
  components: {ChartPie},
  props: {
    label: String,
    costLabel: String,
    count: {
      type: Number,
      required: true
    },
    costAmount: {
      type: Number,
      required: true
    },
    chartData: {
      type: Object,
      default: {}
    },
    chartDataIsLoaded: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    formatDigit(value) {
      if (!value) return '--'
      return utils.formatDigit(value, 1)
    },
    formatCurrency(value) {
      if (!value) return '--'
      return utils.formatCurrency(value)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.campaign_stat_box {
  position: relative;
  margin-bottom: 16px;
  padding: 10px;
  border: 1px solid $border;

  @media (min-width: 1380px) {
    display: flex;
    flex: auto;
    align-items: center;
  }

  &--sections {
    width: 100%;
  }

  &--section {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    &--heading {
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      color: $text-muted;
    }

    &--stat--count {
      font-size: 25px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
